import {setQueryParam} from 'src/utils/url';
import {createRoot} from 'react-dom/client';
import React from 'react';
import ProductDetailsPage from '../../components/ProductDetailsPage';

class Style {
  constructor() {
    this.root = '.pc-Style';
    this.colorDirectToLab = this.colorDirectToLab.bind(this);
    this.updateSelectedColor = this.updateSelectedColor.bind(this);
    this.updateQuoteUrlParams = this.updateQuoteUrlParams.bind(this);
    this.updateUrl = this.updateUrl.bind(this);
    this.toggleSampleRequestForm = this.toggleSampleRequestForm.bind(this);
    this.nonInteractiveSwatchSelector = '.pc-Swatch-noninteractive';
    this.nonInteractiveTrimSwatchSelector =
      '.pc-Swatch-noninteractive .pc-Swatch-trim';
    this.scrollTriggerSelector = 'a[data-scrollto]';
    this.selectedColorNameSelector = '.pc-Style-selectedColor-name';
    this.colorDirectToLabSelector = '.pc-Style-hero-allColors > a';
    this.designLabComplementsLinkSelector =
      '.pc-Style-complements-textSubtitle-link';

    this.enabledColorDirectToLab = false;
    this.shouldFireRequestSampleTooltipEvent = true;

    $(document).on(
      'click.colordirecttolab',
      this.colorDirectToLabSelector,
      this.colorDirectToLab
    );
    $(document).on(
      'click.style.scrollto',
      `.pc-Style ${this.scrollTriggerSelector}`,
      this.scrollTo
    );
    $(document).on(
      'swatchselect.style.colorinteraction',
      this.updateSelectedColor
    );
    $(document).on('updated.style.quoting', this.updateQuoteUrlParams);
    $(document).on('showtooltip', (e, $tgt) => this.toolTipHanlder($tgt));
    $(document).on(
      'click',
      '.pc-Style-requestSamplePla',
      this.toggleSampleRequestForm
    );

    enquire.register(StyleBitz.Layouts.sm, () => {
      return (this.enabledColorDirectToLab = true);
    });
    enquire.register(StyleBitz.Layouts.md, () => {
      return (this.enabledColorDirectToLab = true);
    });
    enquire.register(StyleBitz.Layouts.lg, () => {
      return (this.enabledColorDirectToLab = false);
    });
    enquire.register(StyleBitz.Layouts.xl, () => {
      return (this.enabledColorDirectToLab = false);
    });

    const placeholder = document.getElementById('product-details-page');
    const navRoot = createRoot(placeholder);
    placeholder &&
      navRoot.render(
        <ProductDetailsPage
          productProps={JSON.parse(
            placeholder.getAttribute('data-product-props')
          )}
          ttarpNumber={placeholder.getAttribute('data-sb-ttarp-number')}
          mainImage={JSON.parse(placeholder.getAttribute('data-ss-main-image'))}
          iframed={placeholder.getAttribute('data-iframed') === 'true'}
          variant={JSON.parse(placeholder.getAttribute('data-variant'))}
          compatibilityModeDisabled={
            placeholder.getAttribute('data-compatibility-mode-disabled') ===
            'true'
          }
          sampleQuote={placeholder.getAttribute('data-sample-quote')}
          samplePrice={placeholder.getAttribute('data-sample-price')}
          checkoutAction={placeholder.getAttribute('data-checkout-action')}
          sampleOrderType={placeholder.getAttribute('data-sample-order-type')}
          sampleQuoteCid={placeholder.getAttribute('data-sample-quote-cid')}
          sampleLinkClass={placeholder.getAttribute('data-sample-link-class')}
          sampleLinkHref={placeholder.getAttribute('data-sample-link-href')}
          renderSampleForm={
            placeholder.getAttribute('data-render-sample-form') === 'true'
          }
          blanksOrdering={
            placeholder.getAttribute('data-blanks-ordering') === 'true'
          }
          categoryInfo={JSON.parse(
            placeholder.getAttribute('data-category-info')
          )}
          previewUploadEnabledCategoryIds={JSON.parse(
            placeholder.getAttribute('data-preview-upload-categories') || '[]'
          )}
        />
      );
  }

  // Private (GA Tags)

  fireRequestSampleTooltip() {
    if (!this.shouldFireRequestSampleTooltipEvent) {
      return;
    }
    CustomInk.Metrics.fireEvent('request sample', 'hover', null);
    return (this.shouldFireRequestSampleTooltipEvent = false);
  }

  // Private (event and breakpoint handlers)

  toolTipHanlder($tgt) {
    if ($tgt.id === 'request_sample_tooltip') {
      return this.fireRequestSampleTooltip();
    }
  }

  scrollTo(e) {
    if (e != null) {
      e.preventDefault();
    }
    return StyleBitz.Utils.scrollTop(
      $($(e.target || this).attr('href')).offset().top - 16
    );
  }

  colorDirectToLab(e) {
    if (
      !ProductCatalog.IFrame.isIframer('ndx') ||
      !this.enabledColorDirectToLab
    ) {
      return true;
    }
    if (e != null) {
      e.preventDefault();
    }
    if (e != null) {
      e.stopPropagation();
    }
    return ProductCatalog.PostMessenger.productSelected({
      styleId: this.styleId(),
      colorId: this.colorId(),
      categoryPath: this.categoryPath(),
      categoryTree: this.categoryTree(),
      nextPath: '/productColor'
    });
  }

  updateSelectedColor(e, data) {
    $(this.selectedColorNameSelector).text(data.name);
    if (!ProductCatalog.QuickView.isQuickView()) {
      this.updateUrl({PK: data.id});
    }
    // Update productid for the samples form
    $('.pc-Style-samplesForm #product_id').val(data.colorid);
    this.displayColorSizelistandWarning(data);
    // Update noninteractive swatches with new data-attrs
    const $el = $(this.nonInteractiveSwatchSelector)
      .css({
        'background-color': data.color,
        'border-color': 'rgba(0, 0, 0, 0.2)'
      })
      .attr('title', data.name);
    $(this.nonInteractiveTrimSwatchSelector)
      .css('background-color', data.trimColor)
      .prop('hidden', data.trimColor ? false : true);
    return $.each(data, (k, v) => {
      k = k.replace(/([A-Z])/, (_, match) => `-${match.toLowerCase()}`);
      return $el.attr(`data-${k}`, v);
    });
  }

  updateQuoteUrlParams(e, data) {
    const params = {};
    if (data != null && data.original != null) {
      params.quote_qty = data.original.quantity;
      params.quote_fc = data.original.color_counts_front;
      params.quote_bc = data.original.color_counts_back;
      return this.updateUrl(params);
    }
  }

  // Private (helpers)

  updateUrl(params) {
    if (params == null) {
      params = {};
    }
    let url = window.location.href;
    for (let key of Array.from(Object.keys(params))) {
      url = setQueryParam(key, params[key], url);
    }
    const title = $('title').text();
    return window.history.replaceState({}, title, url);
  }

  styleId() {
    return $(this.nonInteractiveSwatchSelector).eq(0).attr('data-styleid');
  }

  colorId() {
    return $(this.nonInteractiveSwatchSelector).eq(0).attr('data-id');
  }

  categoryPath() {
    return $('meta[property="categoryinfo"]').attr('path');
  }

  categoryTree() {
    return $('meta[property="categoryinfo"]').attr('category_tree');
  }

  toggleSampleRequestForm() {
    return $('.pc-Style-hero-samples').toggle('slow');
  }

  displayColorSizelistandWarning(data) {
    $('.pc-Style-hero-colors-sizeList').html(data.colorSizeListHtml);
    $('.pc-Style-hero-colors-stockWarning').html(data.colorSizesStockWarning);
  }
}

jQuery(() => (ProductCatalog.Style = new Style()));
